export const SHARED_ME = "shared-with-me";
export const SHARE_WITH = "i-share-with";

export const tabs = [
  { label: "Shared With Me", value: SHARED_ME },
  { label: "I Share With", value: SHARE_WITH },
]